// src/constants/minValues.js
import BigNumber from 'bignumber.js';

export const MIN_VALUES = {
    entryPrice: new BigNumber(0.00000001),
    stopLoss: new BigNumber(0.00000001),
    risk: new BigNumber(0.01),
    accountBalance: new BigNumber(1),
    nominalRR: new BigNumber(0.1),
    maxLeverage: new BigNumber(1),
    safetyBufferR: new BigNumber(0.25),
    entryFee: new BigNumber(0),
    exitFee: new BigNumber(0),
    totalTrades: 1,
    winRate: 1,
    maxDailyLosses: 1
};